/**
 * @generated SignedSource<<bbe410690bd9d865e0c920cdd440347c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActionItemIntegrationsSyncIncompleteActionItemsMutation$variables = {};
export type ActionItemIntegrationsSyncIncompleteActionItemsMutation$data = {
  readonly syncIncompleteActionItemsToUserIntegration: {
    readonly result: any | null;
    readonly viewer: {
      readonly integrations: {
        readonly userLevelActionItemIntegration: {
          readonly lastSyncDate: string | null;
          readonly syncedActionItemCount: number | null;
          readonly unsyncedActionItemCount: number | null;
        } | null;
      };
    } | null;
  } | null;
};
export type ActionItemIntegrationsSyncIncompleteActionItemsMutation = {
  response: ActionItemIntegrationsSyncIncompleteActionItemsMutation$data;
  variables: ActionItemIntegrationsSyncIncompleteActionItemsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsyncedActionItemCount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncedActionItemCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSyncDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemIntegrationsSyncIncompleteActionItemsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "SyncIncompleteActionItemsToUserIntegrationPayload",
        "kind": "LinkedField",
        "name": "syncIncompleteActionItemsToUserIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActionItemIntegrationNode",
                    "kind": "LinkedField",
                    "name": "userLevelActionItemIntegration",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": "syncIncompleteActionItemsToUserIntegration(input:{})"
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ActionItemIntegrationsSyncIncompleteActionItemsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "SyncIncompleteActionItemsToUserIntegrationPayload",
        "kind": "LinkedField",
        "name": "syncIncompleteActionItemsToUserIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActionItemIntegrationNode",
                    "kind": "LinkedField",
                    "name": "userLevelActionItemIntegration",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": "syncIncompleteActionItemsToUserIntegration(input:{})"
      }
    ]
  },
  "params": {
    "cacheID": "55643dc4dd0e060734bfe892257efba9",
    "id": null,
    "metadata": {},
    "name": "ActionItemIntegrationsSyncIncompleteActionItemsMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemIntegrationsSyncIncompleteActionItemsMutation {\n  syncIncompleteActionItemsToUserIntegration(input: {}) {\n    viewer {\n      integrations {\n        userLevelActionItemIntegration {\n          unsyncedActionItemCount\n          syncedActionItemCount\n          lastSyncDate\n          id\n        }\n      }\n      id\n    }\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca47cf2c9d82e83b55c70c3dca72e877";

export default node;
